import * as React from 'react';
import { ArrowLeftIcon } from '@mentimeter/ragnar-visuals';
import type { Placement } from '@mentimeter/presentation-state';
import type { ClickableT } from '@mentimeter/ragnar-ui/clickable';
import { useTranslations } from 'next-intl';
import { Hotkey } from '../../misc/hotkeys/Hotkey';
import { ToolbarButton } from '../ToolbarItem';

interface PreviousProps extends ClickableT {
  previous: (placement: Placement) => void;
  previousSlide: (placement: Placement) => void;
  hasPreviousSlide: boolean;
  hasPrevious: boolean;
  disableHotkeys?: boolean;
  hideTooltip?: boolean;
}

export const Previous = ({
  previous,
  previousSlide,
  hasPrevious,
  hasPreviousSlide,
  disableHotkeys = false,
  hideTooltip = false,
  ...rest
}: PreviousProps) => {
  const translate = useTranslations('presenting.legacy');

  return (
    <>
      <ToolbarButton
        {...rest}
        ariaLabel={translate('toolbar.previous_slide')}
        id="previous-slide"
        data-testid="toolbar-previous"
        icon={ArrowLeftIcon}
        disabled={!hasPreviousSlide}
        hideTooltip={hideTooltip}
        label={translate('toolbar.previous_slide')}
        onClick={() => previousSlide('Navigation button')} // Once Linear Navigation is live, this should call the previous function instead
      />
      {!disableHotkeys && hasPrevious && (
        <>
          <Hotkey
            preventDefault
            keyCode="pageup"
            action={() => previous('Hotkey pageup')}
          />
          <Hotkey
            preventDefault
            keyCode="arrowleft"
            action={() => previous('Hotkey arrowleft')}
          />
        </>
      )}
    </>
  );
};
